import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  InputsDiv,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import Lock from "../../styles/images/img_lock.png";
import OnePageLayout from "../../components/layout/OnePageLayout";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../store/slices/userSlice";
import { getToken } from "../../components/hooks/authFunc";
import { Modal } from "../../components/modal/Modal";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";

const EditInfoPassword = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const [checkedPw, setCheckedPw] = useState(false);
  const [checkedConfirmPw, setCheckedConfirmPw] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });

  const changeUserPasswordSuccess = useSelector(
    (state) => state.user.changeUserPasswordSuccess
  );
  const modalMsg = useSelector((state) => state.user.modalMsg);

  useEffect(() => {
    const passwordRegex =
      /^(?=.*[~!@#$%^&*()?])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[~!@#$%^&*()?a-zA-Z0-9]{8,20}$/;
    if (passwordRegex.test(passwords.password)) {
      setCheckedPw(true);
    } else {
      setCheckedPw(false);
    }

    if (
      passwords.password &&
      passwords.password === passwords.confirmPassword
    ) {
      setCheckedConfirmPw(true);
    } else {
      setCheckedConfirmPw(false);
    }
  }, [passwords]);

  const handleChangePassword = () => {
    const params = {
      password: passwords.password,
      confirmPassword: passwords.confirmPassword,
    };
    dispatch(userActions.fetchChangeUserPassword({ params, accessToken }));
  };

  useDidMountEffect(() => {
    if (changeUserPasswordSuccess)
      navigate("/mypage/edit/result", { state: { type: "password" } });
  }, [changeUserPasswordSuccess]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);

  return (
    <OnePageLayout title="비밀번호 변경">
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      <Section>
        <Content>
          <InputsDiv>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 입력하세요."
                name="password"
                value={passwords.password}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                <p>
                  8~20자 영문 대소문자, 숫자, 특수문자 혼합,
                  <br /> 대소문자 구별 (예시 : Abc123!@#)
                  <br /> *사용가능 특수문자 : ~, !, @, #, $, %, ^, &, *, ?,
                  &#40;, &#41;
                </p>
                {!checkedPw && passwords.password != "" && (
                  <p className="pink">사용할 수 없는 비밀번호입니다.</p>
                )}
                {checkedPw && (
                  <p className="col">사용 가능한 비밀번호입니다.</p>
                )}
              </SettingPwInfo>
            </div>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 한번 더 입력 부탁드립니다."
                name="confirmPassword"
                value={passwords.confirmPassword}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                {checkedConfirmPw && (
                  <p className="col">비밀번호가 일치합니다.</p>
                )}
              </SettingPwInfo>
            </div>
          </InputsDiv>
          <ImgWarp>
            <img src={Lock} alt="" />
          </ImgWarp>
        </Content>
        <Btns>
          <ButtonL
            disabled={!(checkedPw && checkedConfirmPw)}
            onClick={() => {
              handleChangePassword();
            }}
          >
            확인
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default EditInfoPassword;
const SettingPwInfo = styled(TextDiv)`
  text-align: left;
  p {
    margin-top: 1rem;
  }
`;

const ImgWarp = styled.div`
  margin-top: 5.5rem;
  text-align: center;
  img {
    width: 17.7rem;
  }
`;
